import C from "@/utils/constants";
import type { CellBoundingBox } from "@/types/api";

export const isMarkedCell = (cell: CellBoundingBox): boolean =>
  cell.tag === C.CELL_TAGS.SELECTED || cell.tag === C.CELL_TAGS.UNCLASSIFIED;

export const clearCellTag = (cell: CellBoundingBox): CellBoundingBox => 
  ({ ...cell, tag: "" } as CellBoundingBox);

export const cellIdentityKey = (cell: Pick<CellBoundingBox, "tile_id" | "img_url">): string =>
  `${cell.tile_id}\u0000${cell.img_url}`;

export const matchesCellIdentity = (
  cell: CellBoundingBox,
  tileId: number,
  imageUrl?: string,
): boolean => cell.tile_id === tileId && (imageUrl === undefined || cell.img_url === imageUrl);

export const moveCellsBetweenArrays = (
  cellsToMove: CellBoundingBox[],
  sourceCellArray: CellBoundingBox[],
  targetCellArray: CellBoundingBox[]
): { nextSourceCellArray: CellBoundingBox[]; nextTargetCellArray: CellBoundingBox[] } => {
  if (!cellsToMove.length) {
    return { nextSourceCellArray: sourceCellArray, nextTargetCellArray: targetCellArray };
  }

  const identitiesToMove = new Set(cellsToMove.map(cellIdentityKey));
  const clearedCells = cellsToMove.map(clearCellTag);

  const nextSourceCellArray = sourceCellArray.filter(
    (cell) => !identitiesToMove.has(cellIdentityKey(cell)),
  );
  const nextTargetCellArray = targetCellArray
    .filter((cell) => !identitiesToMove.has(cellIdentityKey(cell)))
    .concat(clearedCells);

  return { nextSourceCellArray, nextTargetCellArray };
};
